import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import URLS from 'redux/urls'
import request from 'redux/utils/request'

export const fetchAllKomisi = createAsyncThunk(
    'Komisi/fetchAllKomisi',
    async (params, { rejectWithValue }) => {
        try {
            const response = await request('get', URLS.KOMISI, params)
            return response
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const addKomisi = createAsyncThunk(
    'Komisi/addKomisi',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await request('post', URLS.KOMISI, payload)
            return response
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const updateKomisi = createAsyncThunk(
    'Komisi/updateKomisi',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await request('patch', `${URLS.KOMISI}/${payload.id}`, payload)
            return response
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)
export const fetchOneKomisi = createAsyncThunk(
    'Komisi/fetchOneKomisi',
    async (id, { rejectWithValue }) => {
        try {
            const response = await request('get', `${URLS.KOMISI}/${id}`)
            return response
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const deleteKomisi = createAsyncThunk(
    'Komisi/deleteKomisi',
    async (id, { rejectWithValue }) => {
        try {
            const response = await request('delete', `${URLS.KOMISI}/${id}`)
            return response.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

const initialState = {
    loading: {
        query: false,
        mutation: false
    },
    filter: {
        q: ''
    },
    list: [],
    count: {},
    selected: {},
    selectedRows: []
}

const loadingReducer = (fieldName, status) => (state) => {
    state.loading[fieldName] = status
}

const startLoadingQuery = loadingReducer('query', true)
const stopLoadingQuery = loadingReducer('query', false)
const startLoadingMutation = loadingReducer('mutation', true)
const stopLoadingMutation = loadingReducer('mutation', false)

export const KomisiSlice = createSlice({
    name: 'Komisi',
    initialState,
    reducers: {
        setAppliedSearchText: (state, action) => {
            state.filter.q = action.payload
        },
        setSelectedRows: (state, action) => {
            state.selectedRows = action.payload
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchAllKomisi.pending, startLoadingQuery)
            .addCase(fetchAllKomisi.fulfilled, (state, action) => {
                state.list = action.payload
                state.loading.query = false
            })
            .addCase(fetchAllKomisi.rejected, stopLoadingQuery)
        builder
            .addCase(fetchOneKomisi.pending, startLoadingQuery)
            .addCase(fetchOneKomisi.rejected, stopLoadingQuery)
            .addCase(fetchOneKomisi.fulfilled, (state, action) => {
                state.loading.query = false
                state.selected = action.payload
            })
        builder
            .addCase(updateKomisi.pending, startLoadingQuery)
            .addCase(updateKomisi.rejected, stopLoadingQuery)
            .addCase(updateKomisi.fulfilled, (state, action) => {
                state.loading.query = false
                state.selected = action.payload
            })
        builder
            .addCase(deleteKomisi.pending, startLoadingMutation)
            .addCase(deleteKomisi.fulfilled, stopLoadingMutation)
            .addCase(deleteKomisi.rejected, stopLoadingMutation)
    }
});


export const { setSelectedRows, setAppliedSearchText } = KomisiSlice.actions;

export default KomisiSlice.reducer;